import axios from 'axios';
import {WEBSITE_URL} from './../configs/website';
import Cookies from 'js-cookie';

const apiClient = axios.create({
  baseURL: WEBSITE_URL, // e.g. http://server.test
  withCredentials: true,
  headers: {
    'Content-Type': 'application/json',
    Accept: 'application/json',
  },
  xsrfCookieName: 'XSRF-TOKEN',
  xsrfHeaderName: 'X-XSRF-TOKEN',
});


apiClient.interceptors.request.use((config) => {
  const token = Cookies.get('XSRF-TOKEN');
  if (token) {
    config.headers['X-XSRF-TOKEN'] = token;
  }
  return config;
});

export default apiClient;
